export default __webpack_public_path__ + "static/media/Blog10.08bfebb3.png";